import { useAuth0 } from "@auth0/auth0-react";
import { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { COMPETITIONS_API_BASEURL } from "~shared/constants";
import { useNotification } from "./useNotification";

export const useHttp = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { getAccessTokenSilently: getTokenSilently, getIdTokenClaims } = useAuth0();
  const [_shouldRefetch, refetch] = useState({});

  const { customerId } = useParams();

  const notification = useNotification();

  const request = useCallback(
    async ({ url, method = "GET", body, headers = {}, fileBody = undefined }) => {
      setLoading(true);

      try {
        const token = await getIdTokenClaims();
        const accessToken = await getTokenSilently();
        if (customerId) {
          headers["x-customer-id"] = customerId;
        }
        if (accessToken) {
          headers["x-user-identity-token"] = accessToken;
        }

        headers.Authorization = `Bearer ${token.__raw}`;
        if (body) {
          body = JSON.stringify(body);
          headers["Content-Type"] = "application/json";
        }
        if (fileBody) {
          headers["Content-Type"] = fileBody.type || "application/octet-stream";
        }

        const response = await fetch(COMPETITIONS_API_BASEURL + url, {
          method,
          body: body || fileBody,
          headers,
        });
        const data = await response.json();

        if (!response.ok) {
          if (response.status === 403) {
            setLoading(false);
            notification.error({
              message: "You are not authorized to perform this action.",
              placement: "bottomRight",
            });
            //                        throw new Error('You are not authorized to perform this action.');
            return { status: 403, error: "You are not authorized to perform this action." };
          } else {
            setLoading(false);
            const errorMsg = data.Message || data.message || data.errors?.message || data.error?.message || "Unexpected error";
            throw new Error(errorMsg);
          }
        }

        setLoading(false);

        return data;
      } catch (e) {
        setLoading(false);
        setError(e.message);
        throw e;
      }
    },
    [getIdTokenClaims, getTokenSilently, customerId, notification.error],
  );

  const cleanError = useCallback(() => setError(null), []);

  return {
    loading,
    error,
    request,
    cleanError,
    refetch: () => refetch(new Date()),
  };
};
